import { ChatService } from "../../APIService/ChatService";

// do not change the following line, it will be patched on build stage with the actual key from secrets
const vapidPublicKey = import.meta.env.VITE_PUBLIC_VAPID_KEY;

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function initServiceWorker() {
  try {
    const swRegistration = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });

    const pushManager = swRegistration.pushManager;

    if (!pushManager) {
      return "none";
    }

    const permissionState = await pushManager.permissionState({
      userVisibleOnly: true,
    });

    switch (permissionState) {
      case "prompt": // Разрешение на push-уведомления пока не дано
        return "prompt";
      case "granted": {
        // Разрешение на push-уведомления дано
        const existingSubscription = await pushManager.getSubscription();
        if (existingSubscription) {
          ChatService.savePushSubscription(existingSubscription).then(() => {
            console.log("Saved");
          });
        }
        return "granted";
      }
      case "denied": // Пользователь отказал в разрешении push-уведомлений
        return "denied";
    }
  } catch (error) {
    console.error("Service Worker initialization error:", error);
    return "error";
  }
}

export async function subscribeToPush() {
  if (!vapidPublicKey) {
    console.error("VAPID key is not configured");
    return false;
  }

  try {
    const swRegistration = await navigator.serviceWorker.ready;
    const pushManager = swRegistration.pushManager;

    if (!pushManager) {
      return false;
    }

    const subscriptionOptions = {
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    };

    const subscription = await pushManager.subscribe(subscriptionOptions);

    ChatService.savePushSubscription(subscription).then(() => {
      console.log("Saved");
    });
    return true;
  } catch (error) {
    console.error("Push subscription error:", error);
    return false;
  }
}
